module.exports = __webpack_public_path__ + "static/media/void.f77d018d.svg";